<template>
  <card class="wrapper-order">
    <div class="order-info">
      <el-image
        style="
          width: 100px;
          border-radius: 8px;
          height: 100px;
          margin-right: 20px;
        "
        :src="detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : ''"
        :preview-src-list="[detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : '']"
      >
        <div
          style="
            background: #f5f7fa;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            color: #c0c4cc;
          "
          slot="error"
        >
          暂无图片
        </div>
      </el-image>

      <div class="order-info-right">
        <div class="order-title">
          <span class="fw700 mr10">{{ detailInfo.orderGoods ? detailInfo.orderGoods.skuTitle : "" }}</span>
          <el-tag type="primary" effect="plain">
            {{ detailInfo.orderGoods ? detailInfo.orderGoods.goodsPurityName : "" }}
          </el-tag>
          <el-tag type="primary" effect="plain">{{ detailInfo.orderTypeName }}</el-tag>
        </div>
        <div class="label">
          订单号：{{ $route.params.id }}
          <el-tag type="primary" effect="plain">{{ detailInfo.statusName }}</el-tag>
        </div>
        <div class="label">下单时间：{{ detailInfo.createTime }}</div>
      </div>
    </div>

    <div>
      <AdminTitle title="费用明细" size="15px" bottom="5px"/>
      <card class="wrapper-order special-card">
        <el-row>
          <el-col
            v-for="(item, index) in orderInfoList"
            :key="index"
            :span="item.width ? item.width : 8"
          >
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ detailInfo[item.prop] || "-" }}{{ item.unit }}</span>
            <!-- 方案 -->
            <i
              v-if="
                item.edit &&
                item.prop == 'storeComboName' &&
                (detailInfo.orderType == 2 || detailInfo.orderType == 4) &&
                isShowBtn(AUTH_BTN.review_list_detail_edit_price_rate)
              "
              @click="updateOrderCombo"
              class="el-icon-edit"
            >
              修改
            </i>
            <!-- 零售价 -->
            <i
              v-if="
                item.edit &&
                item.prop == 'salePrice' &&
                isShowBtn(AUTH_BTN.review_list_detail_edit_cost_price)
              "
              @click="updatePrice"
              class="el-icon-edit"
            >
              修改
            </i>
          </el-col>
        </el-row>
      </card>
    </div>

    <!-- 零售价 -->
    <el-dialog title="修改零售价" :visible.sync="priceDialog" width="350px">
      <el-form ref="periodForm" :model="priceData" label-width="80px">
        <el-form-item label="新零售价">
          <el-input-number
            style="width: 200px"
            v-model="priceData.salePrice"
            size="small"
            :precision="2"
            :min="0"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="priceDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="savePrice" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <EditCombo
      :orderNo="detailInfo.orderNo"
      :comboId="detailInfo.storeComboId"
      :comboRoute="detailInfo.storeComboRoute"
      :rewardComboNum="detailInfo.store?.rewardComboNum"
      :visible.sync="editComboProps.visible"
      @refresh="refresh"
    />
  </card>
</template>

<script>
import { updatePriceAPI } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import EditCombo from "./edit-combo/index.vue";

export default {
  name: "OrderInfo",
  components: { EditCombo },
  inject: ["reload"],
  mixins: [authBtnMixin],

  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },

    flag: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      priceData: {
        salePrice: "",
        orderNo: "",
      },
      orderInfoList: [
        {
          label: "总租金：",
          prop: "rentPrice",
          unit: "元",
        },
        {
          label: "到期申请购买价：",
          prop: "buyoutPrice",
          unit: "元",
        },
        {
          label: "方案：",
          prop: "storeComboName",
          edit: true,
        },
        {
          label: "总期数：",
          prop: "billPeriodNum",
          unit: "期",
        },
        {
          label: "监管服务费：",
          prop: "lockAmount",
          unit: "元",
        },
        {
          label: "零售价：",
          prop: "salePrice",
          unit: "元",
          edit: true,
        },
        {
          label: "首付租金：",
          prop: "prepayRentPrice",
          unit: "元",
        },
        {
          label: "意外保：",
          prop: "insurancePrice",
          unit: "元",
        },
        {
          label: "门店结算：",
          prop: "storeSettleAmount",
          unit: "元",
        },
      ],
      updateFinalGradeDialog: false,
      priceDialog: false,
      editComboProps: {
        visible: false,
      },
    };
  },

  methods: {
    // 保存零售价
    savePrice() {
      updatePriceAPI(this.priceData).then(() => {
        localStorage.setItem("is_update_period", "true");
        this.$emit("update:flag", false);
        this.$emit("updateDetail");
        this.$message.success("修改成功");
        this.priceDialog = false;
      });
    },

    // 打开修改零售价
    updatePrice() {
      this.priceData.orderNo = this.$route.params.id;
      this.priceData.salePrice = this.detailInfo.salePrice;
      this.priceDialog = true;
    },

    // 打开修改方案窗口
    updateOrderCombo() {
      if (!this.detailInfo.orderScoreProfile?.finalHitGrade) {
        return this.$message.error("请先完成用户评级");
      }
      this.editComboProps.visible = true;
    },

    refresh() {
      this.$emit("updateDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-order ::v-deep {
  border-color: transparent;
  width: 100%;
  border-radius: 16px;
  color: #222222;

  .label {
    color: #666666;
    font-size: 14px;
  }

  .order-info {
    display: flex;
    margin-bottom: 10px;

    .order-info-right {
      display: flex;
      flex-direction: column;

      .order-title {
        color: #333333;
        font-size: 18px;
      }

      .label {
        margin-top: 8px;
        font-size: 12px;
      }
    }

    .el-tag {
      height: 25px;
      border-radius: 15px;
      margin-right: 10px;
      line-height: 25px;
    }
  }

  .el-dialog__footer {
    padding-bottom: 30px !important;
  }
}

.special-card {
  background: #f7f8fa;
  color: #222222;
  position: relative;
  padding: 20px;
  overflow: visible;
  
  ::v-deep .el-row {
    margin: 0;
    
    .el-col {
      padding: 12px 0;
      min-height: 44px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }

  .value {
    margin-left: 15px;
    min-width: 80px;
    display: inline-block;
    font-weight: 700;
    line-height: 1.5;
  }

  .label {
    text-align: right;
    min-width: 100px;
    display: inline-block;
    line-height: 1.5;
  }

  .el-icon-edit {
    margin-left: 10px;
    cursor: pointer;
    color: #4badf8;
    line-height: 1.5;
  }
}

.combo-box {
  .combo-item {
    margin-bottom: 10px;

    .title {
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
}

.fw700 {
  font-weight: 700;
}

.mr10 {
  margin-right: 10px;
}
</style>
